// extracted by mini-css-extract-plugin
export default {"counter-container":"style_counter-container__JZk5q","user-counter":"style_user-counter__9cb7W"};